"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
exports.defineLazyImage = defineLazyImage;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Image = _interopRequireWildcard(require("./Image.js"));
var _useInView = require("./useInView.js");
var _excluded = ["alt", "onLoad", "placeholderSrc", "imageHeight", "imageWidth", "borderRadius", "circle", "crop", "fluid"],
  _excluded2 = ["imageHeight", "imageWidth", "borderRadius", "circle", "crop", "fluid", "placeholderIcon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function defineLazyImage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$StyledLazyImage = _ref.StyledLazyImage,
    StyledLazyImage = _ref$StyledLazyImage === void 0 ? _Image.StyledLazyImage : _ref$StyledLazyImage,
    _ref$PlaceholderImage = _ref.PlaceholderImage,
    PlaceholderImage = _ref$PlaceholderImage === void 0 ? _Image.PlaceholderImage : _ref$PlaceholderImage,
    _ref$useInView = _ref.useInView,
    useInView = _ref$useInView === void 0 ? _useInView.useInView : _ref$useInView;
  return function LazyImage(_ref2) {
    var _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _onLoad = _ref2.onLoad,
      placeholderSrc = _ref2.placeholderSrc,
      imageHeight = _ref2.imageHeight,
      imageWidth = _ref2.imageWidth,
      borderRadius = _ref2.borderRadius,
      circle = _ref2.circle,
      crop = _ref2.crop,
      fluid = _ref2.fluid,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    var imageRef = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      inView = _useState2[0],
      setInView = _useState2[1];
    var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isLoaded = _useState4[0],
      setIsLoaded = _useState4[1];
    var lazyImage = /*#__PURE__*/_react["default"].createElement(StyledLazyImage, Object.assign({}, props, {
      alt: alt,
      ref: imageRef,
      onLoad: function onLoad(event) {
        setIsLoaded(true);
        if (_onLoad) {
          _onLoad(event);
        }
      },
      $isLoaded: isLoaded,
      $imageHeight: imageHeight,
      $imageWidth: imageWidth,
      $borderRadius: borderRadius,
      $circle: circle,
      $crop: crop,
      $fluid: fluid
    }));
    var placeholder = /*#__PURE__*/_react["default"].createElement(_Image.PlaceholderImageWrapper, Object.assign({
      $imageHeight: imageHeight,
      $imageWidth: imageWidth,
      $borderRadius: borderRadius,
      $circle: circle,
      $crop: crop,
      $fluid: fluid
    }, props), /*#__PURE__*/_react["default"].createElement(PlaceholderImage, {
      alt: alt,
      ref: imageRef,
      src: placeholderSrc
    }));
    useInView(imageRef, function () {
      setInView(true);
    });
    if (inView) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isLoaded && placeholder, lazyImage);
    }
    return placeholder;
  };
}
var LazyImage = defineLazyImage();

/**
 * Use Image to render a simple image by using a link to its location.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-image--docs) |
 * [Encore site](https://encore.spotify.net/web/components/image) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Image) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=265-10&t=seYnsEY0fRrtuJhj-1)
 */
var Image = exports.Image = function Image(_ref3) {
  var imageHeight = _ref3.imageHeight,
    imageWidth = _ref3.imageWidth,
    borderRadius = _ref3.borderRadius,
    circle = _ref3.circle,
    crop = _ref3.crop,
    fluid = _ref3.fluid,
    placeholderIcon = _ref3.placeholderIcon,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  if ('placeholderSrc' in props && props.placeholderSrc) {
    return /*#__PURE__*/_react["default"].createElement(LazyImage, Object.assign({
      imageHeight: imageHeight,
      imageWidth: imageWidth,
      borderRadius: borderRadius,
      circle: circle,
      crop: crop,
      fluid: fluid
    }, props, {
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Image
    }));
  } else if (placeholderIcon && !props.src) {
    var Icon = placeholderIcon;
    return /*#__PURE__*/_react["default"].createElement(_Image.Placeholder, Object.assign({
      $imageHeight: imageHeight,
      $imageWidth: imageWidth,
      $borderRadius: borderRadius,
      $circle: circle,
      $crop: crop,
      $fluid: fluid
    }, props, {
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Image
    }), /*#__PURE__*/_react["default"].createElement(Icon, null));
  }
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], Object.assign({
    $imageHeight: imageHeight,
    $imageWidth: imageWidth,
    $borderRadius: borderRadius,
    $circle: circle,
    $crop: crop,
    $fluid: fluid
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Image
  }));
};